let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Iszu")).then(() => parcelRequire('kIIx6'));